<style lang="scss">
    .zoezi-news-dialog{
        .zoezi-date, .zoezi-author{
            font-size: 12px;
            color:#999;
            margin-right: 10px;
            .v-icon{
                margin-right: 5px;
            }
        }
        .v-image{
            margin-left:-24px; margin-right:-24px;
            max-width: calc(100% + 48px);
            .v-btn{
                background-color:rgba(0,0,0,.3);
            }
        }
    }

</style>
<template>
    <div>
        <news-compose v-if="hasPostPermission" :categories="categories" />
        <v-switch v-if="hasPostPermission" v-model="showUnpublished" :label="$translate('Only show unpublished news')" />

        <section class="zoezi-news-items" :class="{'zoezi-news-blog' : blogStyle}">
            <news-card
                v-for="item in filteredNewsItems"
                :key="item.id"
                :item="item"
                class="zoezi-news-card"
                :show-date="showDate"
                :show-author="showAuthor"
                :blog-style="blogStyle"
                :flat="flat"
                :tile="flat"
                @clicked="showNewsCard(newsItemPage, item)"
                :to="item.to"
            />
        </section>

        <v-dialog v-if="currentArticle" v-model="currentArticle" scrollable max-width="600px" transition="dialog-bottom-transition">
            <v-card class="zoezi-news-dialog">
                <v-btn icon @click="currentArticle = null" color="white" style="position: absolute; z-index: 1; right: 0;"><v-icon>mdi-close</v-icon></v-btn>
                <news-display :value="currentArticle"
                              :show-date="showDate"
                              :show-author="showAuthor"/>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn block color="primary" text @click="currentArticle = false">
                        {{$translate('Close')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import NewsCard from '../components/NewsCard.vue'
import NewsCompose from '../components/NewsCompose.vue'
import NewsDisplay from './NewsDisplay.vue'
import {makeValidPathFromTitle} from '../util.js'
export default {
    name: 'zoezi-news-list',

    zoezi: {
        title: 'News list',
        icon: 'mdi-newspaper-variant-outline',
        getDefaultStyle: () => ({
            pageParams: [
                {
                    id: 'n',
                    prop: 'currentArticleTitle'
                },
                {
                    id: 'id',
                    prop: 'currentArticleId'
                },
                {
                    slug: 'slug',
                    prop: 'currentArticleSlug'
                }
            ]
        })
    },

    components: {
        NewsCompose,
        NewsDisplay,
        NewsCard
    },

    props: {
        categories: {
            title: 'Categories',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                placeholder: 'Show all news',
                text: 'name',
                value: 'id',
                getItems: () => window.$zoeziapi.get('/api/news/category/get')
            }
        },
        blogStyle: {
            title: 'Show the full news without clicking',
            type: Boolean,
            default: false
        },
        showDate: {
            title: 'Show date',
            type: Boolean,
            default: true
        },
        showAuthor: {
            title: 'Show author',
            type: Boolean,
            default: true
        },
        flat: {
            title: 'Flat list',
            type: Boolean,
            default: false
        },
        maxNumberOfItems: {
            title: 'Maximum number of news items displayed',
            typeinfo: {
                placeholder: 'Show all news'
            },
            type: Number
        },
        newsItemPage: {
            title: 'Page with news posts',
            type: String,
            fulltype: 'page'
        },
        currentArticleId: {
            title: 'Show news - ID',
            type: Number
        },
        currentArticleTitle: {
            title: 'Show news - headline',
            type: String
        },
        currentArticleSlug: {
            title: 'Show news - SEO friendly slug',
            type: String
        }
    },

    data: () => ({
        newsItems: [],
        currentArticle: null,
        editArticle: false,
        showUnpublished: false
    }),

    watch: {
        currentArticle: {
            immediate: false,
            handler(currentArticle) {
                let id = currentArticle ? currentArticle.id : null;
                if (id != this.currentArticleId) {
                    this.setProp('currentArticleId', id);
                }
                let slug = currentArticle ? currentArticle.slug : null;
                if (slug != this.currentArticleSlug) {
                    this.setProp('currentArticleSlug', slug);
                }
                let title = currentArticle ? makeValidPathFromTitle(currentArticle.title).substring(1) : null;
                if (title != this.currentArticleTitle) {
                    this.setProp('currentArticleTitle', title);
                }
            }
        }
    },

    computed: {
        hasPostPermission() {
            return this.$store.state?.user?.permissions?.find(x => x == 'Mailing handling');
        },
        filteredNewsItems() {
            let items = this.newsItems;
            items = items.filter((i) =>  this.showUnpublished ? !this.isPublished(i) : this.isPublished(i));
            if (this.maxNumberOfItems) {
                items = items.slice(0, this.maxNumberOfItems);
            }

            if (this.newsItemPage && !this.$root.edit) {
                items.forEach(item => {
                    item.to = this.newsItemPage + '/' + item.slug;
                })
            }

            return items;
        }
    },

    methods: {
        getNewsItems() {
            this.$api.get('/api/news/list/get', {categories: (this.categories || []).filter(x => x)}).then(items => {
                this.newsItems = items;
                if (this.currentArticleId) {
                    this.currentArticle = this.newsItems.find(x => x.id == this.currentArticleId);
                } else if (this.currentArticleSlug) {
                    this.currentArticle = this.newsItems.find(x => x.slug == this.currentArticleSlug);
                } else if (this.currentArticleTitle) {
                    this.currentArticle = this.newsItems.find(x => makeValidPathFromTitle(x.title).substring(1) == this.currentArticleTitle);
                }
            });
        },
        showNewsCard(newsItemPage, item) {
            if(newsItemPage) {
                this.$root.followLink(newsItemPage, `/${item.slug}`);
            } else {
                this.currentArticleSlug = item.slug;
                this.setProp('currentArticleSlug', item.slug);
                this.setProp('currentArticleId', item.id);
                this.currentArticle = item;
            }
        },
        isPublished(item) {
            return !Date.newFull(item.published).isFuture()
        }
    },

    mounted() {
        this.getNewsItems();

        this.$root.$api.subscribe({type: 'newsitem', callback: () => this.getNewsItems()});
    }
}
</script>
